import React, { Fragment } from 'react';
import { bool, object, string } from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import RootRoute from '../../RootRoute';
import materialUITheme from '../../materialUITheme';
import ToastNotification from '../../containers/ToastNotification'
import FolderDialog from '../../containers/FolderDialog';
import LoadingDialog from '../../containers/LoadingDialog'
import AdBlockDetector from '../../components/AdBlockDetector';
import SharingCampaign from '../../components/SharingDialog/ShareCampaignDialog';
import SharingAdvertiser from '../../components/SharingDialog/ShareAdvertiserDialog';
import AssignOwner from '../../components/SharingDialog/AssignOwnerDialog';
import { modules } from 'veritone-redux-common';
import { selectRoutesMap, selectRouteType } from 'modules/routing';
import { ATTRIBUTE_APPLICATION_ID, hideAppBarPagesList } from '../../helpers/constant';
import classNames from 'classnames';
import styles from './styles.scss';

let headerIntervalId;
const headerIntervalTimeout = 200;
const {
  config: { getConfig },
  user: { userIsAuthenticated }
} = modules;

class App extends React.Component {
  static propTypes = {
    requiresAuth: bool,
    isAuthenticated: bool,
    isAssignOwnerOpen: bool,
    isShareAdvertiserOpen: bool,
    isShareCampaignOpen: bool,
    baseUrl: string,
    currentRouter: object
  }

  state = {
    isAppbarInit: false
  };

  componentDidMount() {
    headerIntervalId = setInterval(this.initHeader, headerIntervalTimeout);
  }

  componentWillUnmount() {
      this.clearHeaderInterval();
  }

  initHeader = () => {
      if (get(window, 'initAiwareJs')) {
          const { baseUrl } = this.props;
          this.clearHeaderInterval();
          window.initAiwareJs({
              applicationId: ATTRIBUTE_APPLICATION_ID,
              baseUrl,
              scopedStyles: true,
              withAuth: true,
              knowledgeBaseURL:
              'https://support.veritone.com/s/topic/0TO4U000000bwFQWAY/',
          }, () => {
            this.setState({
              isAppbarInit: true
            })
          })
      }
  };

  clearHeaderInterval = () => {
      if (headerIntervalId) {
          clearInterval(headerIntervalId);
      }
  }
  
  render() {
    const { requiresAuth, isAuthenticated, isAssignOwnerOpen, isShareAdvertiserOpen, isShareCampaignOpen } = this.props;
    const { isAppbarInit } = this.state;

    const isShowAppBar = !hideAppBarPagesList.some(item => this.props.currentRouter.path.startsWith(item))
    return (
      <div style={{ height: '100%', overflow: 'hidden' }}>

         <div id='aiWareHeaderBar' className={classNames({ [styles.displayBlock]: isShowAppBar,  [styles.displayNone]: !isShowAppBar })}/>
         
    
        <CssBaseline />
        <MuiThemeProvider theme={materialUITheme}>
          <RootRoute isAppbarInit={isAppbarInit} setIsEnableAppbar={this.setIsEnableAppbar} />
          {
            requiresAuth && isAuthenticated && 
            <Fragment>
              { isAssignOwnerOpen && <AssignOwner/> }
              { isShareCampaignOpen && <SharingCampaign/> }
              { isShareAdvertiserOpen && <SharingAdvertiser/> }
            </Fragment>
          }
        </MuiThemeProvider>
        <ToastNotification />
        <FolderDialog />
        <LoadingDialog />
        <AdBlockDetector />
      </div>
    )
  }
}

import { connect } from 'react-redux';
import { namespace, Status } from '../../state/modules/app/dialogStatus/actions'; 
import { DIALOG_ASSIGN_OWNER, DIALOG_SHARE_ADVERTISER, DIALOG_SHARE_CAMPAIGN } from '../../helpers/constant';
import { get } from 'lodash';

export default connect(
  state => {
    const isAuthenticated = userIsAuthenticated(state);
    const routesMap = selectRoutesMap(state);
    const routeType = selectRouteType(state);
    const currentRouter = routesMap[routeType];    
    const requiresAuth = currentRouter.requiresAuth;
    const assignOwnerStatus = get(state, [namespace, 'dialogs', DIALOG_ASSIGN_OWNER, 'status']);
    const shareAdvertiserStatus = get(state, [namespace, 'dialogs', DIALOG_SHARE_ADVERTISER, 'status']);
    const shareCampaignStatus = get(state, [namespace, 'dialogs', DIALOG_SHARE_CAMPAIGN, 'status']);
    const config = getConfig(state);
    const baseUrl = get(config, 'urlApi.graphql');

    return {
      isAuthenticated,
      requiresAuth,
      isAssignOwnerOpen: assignOwnerStatus == Status.STATUS_OPEN,
      isShareAdvertiserOpen: shareAdvertiserStatus == Status.STATUS_OPEN,
      isShareCampaignOpen: shareCampaignStatus == Status.STATUS_OPEN,
      baseUrl,
      currentRouter: currentRouter
    }
  }
)(App);
